import { type FC, type ReactNode } from "react";
import { generatePath, useParams } from "react-router-dom";

import { AbsoluteRoute, type RouteParams } from "../../../../core/routes";
import { type MyLensesLens } from "../../../../gql-generated/types";
import { lensDataContainerStyles } from "../../../../lens/components/shared";
import { useSearchParams } from "../../../../shared/hooks";
import { LinkStyled } from "../../../../shared/styles";

interface LensLinkWrapperProps {
    children: ReactNode;
    lens: MyLensesLens;
}

export const LensLinkWrapper: FC<LensLinkWrapperProps> = ({ lens, children }) => {
    const { submissionId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT]>();
    const searchParams = useSearchParams();

    return (
        <LinkStyled
            className={lensDataContainerStyles}
            to={{
                pathname: generatePath(AbsoluteRoute.SUBMIT_LENS_UPDATE, {
                    submissionId,
                    lensId: lens.id,
                }),
                search: searchParams.toString(),
            }}
        >
            {children}
        </LinkStyled>
    );
};
